var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "s-orders-nav"
  }, [_c('div', {
    staticClass: "s-flex-basis-25"
  }, [_c('button', {
    staticClass: "s-orders-btn ml-3 pl-3 pr-3",
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v(" 返回 ")])]), _c('div', {
    staticClass: "text-center s-flex-basis-50"
  }, [_vm._v("修改數量")])]), _vm.fetching ? _c('p', [_c('Loading')], 1) : _vm._e(), _vm.isClosed && _vm.isOverdueDeadline ? [_c('div', {
    staticClass: "s-mb-6 s-space-y-3 text-center"
  }, [_c('Status', {
    class: 'g-text-secondary',
    attrs: {
      "icon": 'clock',
      "message": '此團已結單'
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.statusInfo)
    }
  })], 1), _vm.product && _vm.groupBuying ? _c('div', {
    staticClass: "s-space-y-8 s-mb-8"
  }, [_c('DescriptionList', {
    attrs: {
      "title": "商品名稱"
    }
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('DescriptionList', {
    attrs: {
      "title": "團購編號"
    }
  }, [_vm._v(_vm._s(_vm.groupBuying.groupbuying_number))])], 1) : _vm._e(), _c('a', {
    staticClass: "s-btn s-btn-primary",
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v("返回")])] : _c('Form', {
    ref: "form",
    attrs: {
      "action": _vm.submit
    }
  }, [_vm.coverImage ? _c('div', {
    staticClass: "s-mb-2"
  }, [_c('img', {
    staticClass: "s-rounded-lg s-w-full",
    attrs: {
      "src": _vm.coverImage
    }
  })]) : _vm._e(), _c('h2', {
    staticClass: "s-text-xl s-text-gray-darker s-font-semibold s-mb-2"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm.groupBuying.type !== 3 ? _c('div', [_c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("商品單價：")]), _c('dd', [_vm._v(_vm._s(_vm.spec.price) + " 元")])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("結單時間：")]), _c('dd', [_vm._v(_vm._s(_vm.endAt))])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("取貨方式：")]), _c('dd', [_vm._v(_vm._s(_vm.deliveryMethods))])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("付款方式：")]), _c('dd', [_vm._v("下單後立即付款")])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("出貨日期：")]), _c('dd', [_vm._v(_vm._s(_vm.groupBuying.delivery_shipping_day))])])]) : _c('div', [_c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("商品原價：")]), _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.original_price) + " 元")])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("商品售價：")]), _vm.groupBuying.groupbuying_sku.is_promotion ? _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.package_type))]) : _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.price) + " 元")])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("取貨方式：")]), _c('dd', [_vm._v("門市自取")])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("付款方式：")]), _c('dd', [_vm._v("下單後門市付款")])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("取貨期限：")]), _c('dd', [_vm._v(_vm._s(_vm.branchEndAt))])])]), _c('div', {
    staticClass: "s-pb-4 s-mb-4 s-border-b s-border-gray-lighter"
  }), _c('h3', {
    staticClass: "s-text-gray-darker s-font-semibold s-mb-2"
  }, [_vm._v("商品說明")]), _c('div', {
    staticClass: "s-mb-2",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }), _vm.productImages.length ? _c('div', {
    staticClass: "s-mb-2"
  }, _vm._l(_vm.productImages, function (image, i) {
    return _c('img', {
      key: i,
      staticClass: "s-w-full",
      attrs: {
        "src": image
      }
    });
  }), 0) : _vm._e(), _c('div', [_vm.group ? _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', {
    staticClass: "s-whitespace-nowrap"
  }, [_vm._v("跟團群組：")]), _c('dd', [_vm._v(_vm._s(_vm.group.name))])]) : _vm._e(), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', {
    staticClass: "s-whitespace-nowrap"
  }, [_vm._v("團購編號：")]), _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_number))])])]), _c('div', {
    staticClass: "s-product-form"
  }, [_c('Counter', {
    staticClass: "s-mb-4",
    attrs: {
      "label": "下單數量",
      "name": "counter",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.basis,
      "help": "\u4E0B\u55AE\u6578\u91CF\u6700\u591A ".concat(_vm.max, " \u500B\uFF0C\u6700\u5C11 ").concat(_vm.min, " \u500B"),
      "help-class": "s-text-danger",
      "disabled": _vm.groupBuying.type !== 3
    },
    model: {
      value: _vm.quantity,
      callback: function callback($$v) {
        _vm.quantity = $$v;
      },
      expression: "quantity"
    }
  }), _c('div', {
    staticClass: "s-flex s-items-center"
  }, [_c('dl', {
    staticClass: "s-flex-shrink-0 s-flex s-items-center s-mr-2"
  }, [_c('dt', {
    staticClass: "s-mr-2"
  }, [_vm._v("金額")]), _c('dd', {
    staticClass: "s-text-xl s-text-secondary s-price"
  }, [_vm._v("$ " + _vm._s(_vm.price))])]), _vm.groupBuying ? _c('button', {
    staticClass: "s-btn s-btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.groupBuying.type !== 3
    }
  }, [_vm._v(" " + _vm._s(_vm.groupBuying.type !== 3 ? '不支援修改' : '確定修改') + " ")]) : _vm._e()])], 1)])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }